import Call from '../Call.v2';
import {objToQs} from '../Utils';

const AdkCalculus = {
    get(filters) {
        return Call(`adk/calculus?${objToQs(filters)}`);
    },
};

export default AdkCalculus;



// WEBPACK FOOTER //
// ./src/services/API/components/AdkCalculus.js